export enum ESmilesEditorType {
  VISUAL = 'visual',
  TEXTUAL = 'textual',
}

export enum EVisualEditorType {
  KETCHER = 'KETCHER',
}
